<section class="network-page" aria-label="Dynamic network view">
  <header class="network-page__header">
    <h1 class="network-page__title">Network (Dynamic)</h1>
  </header>

  <div class="network-page__frame-container">
    <iframe
      #networkFrame
      (load)="onFrameLoad()"
      class="network-page__frame"
      src="/ontology-dynamic.html"
      title="Ontology Network Dynamic"
      loading="lazy"></iframe>
  </div>
</section>
